import {
  REGISTER_START_REQUEST,
  REGISTER_START_SUCCESS,
  REGISTER_START_FAILURE,
} from 'store/registerGetStart/registerGetStartAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const registerStartReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_START_REQUEST:
      return { ...state, loading: true };
    case REGISTER_START_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case REGISTER_START_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default registerStartReducer;
